// extracted by mini-css-extract-plugin
export default {"wrapper":"Ew","subscription":"Fw","select_item":"Gw","is_selected":"Hw","otb":"Iw","radio":"Jw","first_row":"Kw","prices":"Lw","italic":"Mw","info_wrapper":"Nw","first_month":"Ow","separator":"Pw","checkmark":"Qw","bullets":"Rw","bullet":"Sw","checkmarkText":"Tw","button":"Uw","discountBadge":"Vw"};
    if(module.hot) {
      // 1737143654488
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  